import Service from "../DepartmentService";

function GetByDepartmentId() {
    return Service.get('FacultyStaff');
}


const FacultyStaffService = {
    GetByDepartmentId
};

export default FacultyStaffService;
